import { useEffect, useState } from 'react';
import MyApiClient from '../../../../api-client/MyApiClient';
import { useMemberships } from '../../../../hooks/useMemberships';
import { sportDelProdotto } from '../../../components/Util/sportProdotto';

/*
 * Maestri e impianti della struttura. Sono quelli veri e basta: se le chiamate non rispondono gli
 * elenchi restano vuoti e la pagina lo dice, invece di far scegliere nomi che non esistono.
 */
export const useMaestriEImpianti = () => {
    const { getConfirmedMembers, memberships, loading } = useMemberships({ autoFetch: true });
    const [impianti, setImpianti] = useState([]);
    const [erroreImpianti, setErroreImpianti] = useState(false);

    useEffect(() => {
        const leggi = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (!tokenDetailsString) return;
                const token = JSON.parse(tokenDetailsString).idToken;
                const risposta = await new MyApiClient().getVenues(token);
                const elenco = Array.isArray(risposta) ? risposta
                    : Array.isArray(risposta?.data) ? risposta.data
                    : Array.isArray(risposta?.venues) ? risposta.venues : [];
                // Tutti gli sport dell'impianto (puo' averne piu' d'uno)
                setImpianti(elenco.map(v => ({ id: v.id, nome: v.name, sports: sportDelProdotto(v) })));
            } catch (errore) {
                console.error('Corsi: impianti non letti', errore);
                setErroreImpianti(true);
            }
        };
        leggi();
    }, []);

    // Se le API non rispondono, `memberships` può non essere un elenco: senza questo controllo
    // la pagina resta bianca.
    const elencoMembri = !loading && Array.isArray(memberships) ? getConfirmedMembers('COACH') : [];
    // Lo staff ha una riga per ogni sport del maestro: qui un maestro una volta sola, con tutti i suoi sport
    // (segnalazione del 04/11/2026: chi insegna sci e roller compariva due volte)
    const maestri = [];
    for (const m of Array.isArray(elencoMembri) ? elencoMembri : []) {
        const gia = maestri.find(x => x.id === m.userId);
        if (gia) { if (m.sport && !gia.sports.includes(m.sport)) gia.sports.push(m.sport); continue; }
        maestri.push({ id: m.userId, nome: m.name, sports: m.sport ? [m.sport] : [] });
    }

    return {
        maestri,
        impianti,
        caricando: loading,
        vuoto: !loading && (maestri.length === 0 || impianti.length === 0 || erroreImpianti),
    };
};
